import { baseSearchModel } from "src/app/shared/models/baseSearchModel";

export class customerModel extends baseSearchModel {

    SearchString: string;
    FirstName : string;
    LastName : string;
    InvoiceNo : string;
    AccountNo : string
    FranchiseId : string;
 
}

export class customerTransactionModel extends customerModel{
    CustomerId ?: number;
}